import React from "react";
import { Modal, Table, Spin, Tag } from "antd";
import moment from "moment";
import Bridge from "../../constants/Bridge";

class ViewCpibForm extends React.Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      modalLoader: false,
      modalStatus: false,
      list: [],
      selectedOption: "",
      graphdata: [],
      paginationNum: 10,
      loading: false,
    };
  }
  // on load component function
  componentDidMount() {}
  // on change table pagination
  handleTableChange = (pagination, filters, sorter) => {
    this.setState({ paginationNum: pagination.pageSize });
  };
  // show modal
  showDetailsModal = () => {
    let item = this.props.item;
    this.setState({ modalLoader: true }, () => this.getCpibformList(item));
  };
  // get als frs for participant
  getCpibformList = (item) => {
    let eals_id = item.eals_id;
    let params = {
      eals_id,
      participants_accounts_id: item.participants_accounts_id,
    };
    Bridge.radcliff_study
      .get_cpib_form_list(params)
      .then((response) => {
        if (response.status == "1") {
          this.setState({
            list: response.data,
            modalLoader: false,
            modalStatus: true,
          });
        } else {
          this.setState({
            modalLoader: false,
            modalStatus: true,
            list: [],
          });
        }
      })
      .catch(function (error) {});
  };
  // sloe details modal
  hideDetailsModal = () => {
    this.setState({ modalStatus: false });
  };
  render() {
    const dataSource =
      this.state.list &&
      this.state.list.map((item, index) => {
        return {
          key: index,
          condition_talking_with_people_you_know: item,
          condition_communicate_need_say_quickly: item,
          communicating_out_in_your_community: item,
          condition_talking_with_people_do_not_know: item,
          condition_asking_questions_conversation: item,
          communicate_with_small_group_people: item,
          long_communication_of_book_movie: item,
          giving_detailed_information: item,
          getting_turn_fast_moving_conversation: item,
          persuade_friend_different_points_of_view: item,
          date: item,
          total: item.total_score,
        };
      });
    const Columns = [
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: 70,
        render: (item) => {
          let label = "";
          if (item.date_created) {
            label = moment(item.date_created).format("MM/DD/YYYY");
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "…talking with people you know?",
        dataIndex: "condition_talking_with_people_you_know",
        key: "condition_talking_with_people_you_know",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.condition_talking_with_people_you_know;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "…communicating when you need to say something quickly?",
        dataIndex: "condition_communicate_need_say_quickly",
        key: "condition_communicate_need_say_quickly",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.condition_communicate_need_say_quickly;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "…talking with people you do NOT know?",
        dataIndex: "condition_talking_with_people_do_not_know",
        key: "condition_talking_with_people_do_not_know",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.condition_talking_with_people_do_not_know;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "…communicating when you are out in your community?",
        dataIndex: "communicating_out_in_your_community",
        key: "communicating_out_in_your_community",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.communicating_out_in_your_community;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "…asking questions in a conversation?",
        dataIndex: "condition_asking_questions_conversation",
        key: "condition_asking_questions_conversation",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.condition_asking_questions_conversation;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "…communicating in a small group of people?",
        dataIndex: "communicate_with_small_group_people",
        key: "communicate_with_small_group_people",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.communicate_with_small_group_people;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title:
          "…having a long conversation with someone you know about a book movie, show or sports event?",
        dataIndex: "long_communication_of_book_movie",
        key: "long_communication_of_book_movie",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.long_communication_of_book_movie;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "… giving someone DETAILED information?",
        dataIndex: "giving_detailed_information",
        key: "giving_detailed_information",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.giving_detailed_information;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "…getting your turn in a fast-moving  conversation?",
        dataIndex: "getting_turn_fast_moving_conversation",
        key: "getting_turn_fast_moving_conversation",
        width: 120,
        render: (item) => {
          let label = "";
          let text = item.getting_turn_fast_moving_conversation;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title:
          "…trying to persuade a friend or family  member to see a different point of view?",
        dataIndex: "persuade_friend_different_points_of_view",
        key: "persuade_friend_different_points_of_view",
        width: 150,
        render: (item) => {
          let label = "";
          let text = item.persuade_friend_different_points_of_view;
          if (text == "0") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="green">
                  Very much
                </Tag>{" "}
                <span className="tag-font-size-15">(0)</span>
              </>
            );
          } else if (text == "1") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="cyan">
                  Quite a bit
                </Tag>{" "}
                <span className="tag-font-size-15">(1)</span>
              </>
            );
          } else if (text == "2") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="purple">
                  A little
                </Tag>{" "}
                <span className="tag-font-size-15">(2)</span>
              </>
            );
          } else if (text == "3") {
            label = (
              <>
                <Tag className="tag-font-size-15" color="magenta">
                  Not at all
                </Tag>{" "}
                <span className="tag-font-size-15">(3)</span>
              </>
            );
          }
          return (
            <div>
              <div>{label ? label : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        width: 60,
      },
    ];
    return (
      <>
        <a onClick={() => this.showDetailsModal()}>
          {this.props.page && this.props.page == "add-session-entry" ? (
            <i className="fas fa-eye add-session-entry-view-modal-icon"></i>
          ) : (
            <>
              <i
                className="fas fa-eye"
                style={{
                  color: "#000",
                  fontSize: 18,
                  position: "relative",
                  top: 2,
                }}
              ></i>
              <span style={{ fontSize: 14, marginLeft: 10 }}>
                View CPIB Form
              </span>
            </>
          )}
        </a>{" "}
        {/* Start als frs modal  */}
        <Modal
          title={"View CPIB Form"}
          visible={this.state.modalStatus}
          onOk={this.hideDetailsModal}
          onCancel={this.hideDetailsModal}
          width={750}
          footer={false}
        >
          <div>
            <Spin spinning={this.state.modalLoader}>
              <div className="row participant-div">
                <Table
                  dataSource={dataSource}
                  loading={this.state.loading}
                  pagination={{ pageSize: this.state.paginationNum }}
                  columns={Columns}
                  scroll={{ x: 2200 }}
                  onChange={this.handleTableChange}
                />
              </div>
            </Spin>
          </div>
        </Modal>
        {/* End als frs modal  */}
      </>
    );
  }
}
export default ViewCpibForm;
